import React from 'react';
import { motion } from 'framer-motion';
interface ScrollRevealProps {
  children: React.ReactNode;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
  className?: string;
  width?: 'fit-content' | '100%';
}
export function ScrollReveal({
  children,
  delay = 0,
  direction = 'up',
  className = '',
  width = '100%'
}: ScrollRevealProps) {
  const directions = {
    up: {
      y: 40,
      x: 0
    },
    down: {
      y: -40,
      x: 0
    },
    left: {
      x: 40,
      y: 0
    },
    right: {
      x: -40,
      y: 0
    },
    none: {
      x: 0,
      y: 0
    }
  };
  return <div style={{
    width
  }} className={className} data-id="element-496">
      <motion.div initial={{
      opacity: 0,
      ...directions[direction]
    }} whileInView={{
      opacity: 1,
      x: 0,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      delay: delay,
      ease: [0.21, 0.47, 0.32, 0.98] // Custom ease-out
    }} data-id="element-497">
        {children}
      </motion.div>
    </div>;
}